module.exports = __webpack_public_path__ + "img/index_logo.f55fd21f.png";